import { BookX, NotebookPenIcon, WrenchIcon } from "lucide-react";
import CompanyMaintenanceGridCard from "./components/CompanyMaintenanceGridCard";

const CompanyMaintenanceTab = () => {
  return (
    <div className="grid grid-cols-3 gap-4 max-h-[calc(100vh-12rem)] overflow-auto">
      <CompanyMaintenanceGridCard
        Icon={WrenchIcon}
        label="Processos de manutenção (OS)"
        operationKlassToCheckPermission="Admin::Maintenance::Workflows::Filter"
        linkTo="workflows"
      />

      <CompanyMaintenanceGridCard
        Icon={NotebookPenIcon}
        label="Solicitações de Manutenção"
        operationKlassToCheckPermission="Admin::Maintenance::Solicitations::Filter"
        linkTo="solicitations"
      />

      <CompanyMaintenanceGridCard
        Icon={BookX}
        label="Regras de desfazimento"
        operationKlassToCheckPermission="Admin::Maintenance::ScrapRules::Filter"
        linkTo="scrap-rules"
      />
    </div>
  );
}

export default CompanyMaintenanceTab;
